<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="UnnormalTraderRecordReqVo" ref="queryForm" label-width="auto" size="small" inline>


        <div class="query-grid">
          <el-form-item
              :label="$t('initUnTradeRecordPage.timetype2')"
              prop="time"
              class="full-row"
          >
            <el-select
                v-model="UnnormalTraderRecordReqVo.time"

                filterable
                style="width: 500px;"
            >
              <el-option
                  v-for="item in timeList"
                  :key="item.domianName"
                  :label="item.displayName"
                  :value="item.domianName"
              />
            </el-select>
          </el-form-item>



          <el-form-item :label="$t('startDate')" prop="startDate">
            <el-date-picker
                style="width:210px"
                v-model="UnnormalTraderRecordReqVo.startDate"
                type="datetime"
                :placeholder="$t('startDate')"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                :clearable="false"
                :editable="false"
            />
          </el-form-item>



          <el-form-item :label="$t('endDate')" prop="endDate">
            <el-date-picker
                style="width:210px"
                v-model="UnnormalTraderRecordReqVo.endDate"
                type="datetime"
                :placeholder="$t('endDate')"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                :picker-options="endPickerOptions"
                :clearable="false"
                :editable="false"
            />
          </el-form-item>

          <el-form-item
              :label="$t('initUnTradeRecordPage.remark')"
              prop="remark"
          >
            <div class="input-with-more">
              <el-input v-model="UnnormalTraderRecordReqVo.remark" clearable />
            </div>
          </el-form-item>


          <el-form-item
              :label="$t('initUnTradeRecordPage.tradingURL')"
              prop="tradingURL"
          >
            <div class="input-with-more">
              <el-input v-model="UnnormalTraderRecordReqVo.tradingURL" clearable />
            </div>
          </el-form-item>


          <el-form-item
              :label="$t('initUnTradeRecordPage.businessOrderno')"
              prop="businessOrderno"
          >
            <div class="input-with-more">
              <el-input v-model="UnnormalTraderRecordReqVo.businessOrderno" clearable />
            </div>
          </el-form-item>


          <el-form-item
              :label="$t('initUnTradeRecordPage.randomOrderno')"
              prop="randomOrderno"
          >
            <div class="input-with-more">
              <el-input v-model="UnnormalTraderRecordReqVo.randomOrderno" clearable />
            </div>
          </el-form-item>




          <el-form-item
              :label="$t('initUnTradeRecordPage.expReason')"
              prop="expReason"

          >
            <el-select
                v-model="UnnormalTraderRecordReqVo.expReason"

                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  :label="$t('initUnTradeRecordPage.Interface')"
                  value="1"
              />

              <el-option
                  :label="$t('initUnTradeRecordPage.Risk')"
                  value="2"
              />

              <el-option
                  :label="$t('initUnTradeRecordPage.Cardholder')"
                  value="3"
              />
              <el-option
                  :label="$t('initUnTradeRecordPage.other')"
                  value="4"
              />

            </el-select>
          </el-form-item>



          <el-form-item
              :label="$t('initUnTradeRecordPage.gatewayNo')"
              prop="gatewayNo"
          >
            <el-select
                v-model="UnnormalTraderRecordReqVo.gatewayNo"

                clearable
                filterable
                style="width: 100%;"
            >
              <el-option
                  v-for="item in gatewayList"
                  :key="item.gwNo"
                  :label="item.gwNo1"
                  :value="item.gwNo"
              />
            </el-select>
          </el-form-item>







<!--          <el-form-item class="btn-row" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>-->

        </div>
        <div class="btn-row">
          <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>

          <el-button @click="handleReset">{{ $t('reset') }}</el-button>
        </div>
      </el-form>
    </el-card>


    <div class="action-toolbar">
      <el-button
          v-if="hasPermission('merTradeMgr/initUnTradeRecordPage', 'look_detail')"
          :disabled="!hasSearched"
          :loading="updateLoading"
          @click="handleDetail"
          type="primary"
          icon="el-icon-zoom-in"
      >
        {{ $t('button.detail') }}
      </el-button>


      <el-button
          v-if="hasPermission('merTradeMgr/initUnTradeRecordPage', 'downExcel')"
          :disabled="!hasSearched"
          :loading="downloadLoading"
          @click="handledownload"
          type="primary"
          icon="el-icon-download"
      >
        {{ $t('button.download') }}
      </el-button>

    </div>


    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border  style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

        <el-table-column

            width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope">
            <el-radio
                v-model="selectedRowId"
                :label="scope.row.utrNo"
                @change="handleRadioChange(scope.row)"
            >
              {{''}}
            </el-radio>
          </template>
        </el-table-column>




        <el-table-column prop="gwNoName"  :label="$t('initUnTradeRecordPage.gatewayNo')" :min-width="columnWidths.gatewayNo"></el-table-column>
        <el-table-column prop="utrNo"  :label="$t('initUnTradeRecordPage.randomOrderno')" :min-width="columnWidths.randomOrderno" width="250"></el-table-column>
        <el-table-column prop="utrMerOrderno" :label="$t('initUnTradeRecordPage.businessOrderno')"  :min-width="columnWidths.businessOrderno" width="250"></el-table-column>

        <el-table-column :label="$t('initUnTradeRecordPage.tradeMoney')" :min-width="columnWidths.tradeMoney">
          <template slot-scope="scope">
            {{scope.row.utrCurrency +" "+scope.row.utrAmount}}
          </template>
        </el-table-column>
        <el-table-column prop=""  :label="$t('initUnTradeRecordPage.tradingURL')" ></el-table-column>
        <el-table-column prop=""  :label="$t('initUnTradeRecordPage.returnurl')" ></el-table-column>
        <el-table-column prop="tradeDatetime" :label="$t('initUnTradeRecordPage.tradeTime')" :min-width="columnWidths.tradeTime" width="250"></el-table-column>
        <el-table-column prop="utrErrorcode"  :label="$t('initUnTradeRecordPage.wrongcode')" :min-width="columnWidths.wrongcode"></el-table-column>
        <el-table-column prop="utrErrorreasonOut"  :label="$t('initUnTradeRecordPage.wronginfo')":min-width="columnWidths.wronginfo"></el-table-column>
        <el-table-column prop="utrMerRemark"  :label="$t('initUnTradeRecordPage.remark')" :min-width="columnWidths.remark"></el-table-column>






      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50]"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          style="margin-top: 16px; text-align: right;"
      />
    </el-card>



    <!--  弹窗  -->
    <el-drawer
        :title="$t('initUnTradeRecordPage.untradedetailinfo')"
        :visible.sync="dialogVisible"
        :before-close="handleDrawerClose"
        direction="rtl"
        size="50%"


    >

      <el-form
          ref="form"
          :model="formData"
          label-width="120px"
          class="heavy-disabled"
      >

        <el-form-item :label="$t('initUnTradeRecordPage.randomOrderno')" >
          <el-input v-model="formData.untr.utrNo" :disabled="true"/>
        </el-form-item>

        <el-form-item :label="$t('initUnTradeRecordPage.businessmanNo')"  >
          <el-input v-model="formData.untr.utrMerNo" :disabled="true"/>
        </el-form-item>

        <el-form-item :label="$t('initUnTradeRecordPage.gatewayNo')" >
          <el-input v-model="formData.untr.gwNoName" :disabled="true"/>
        </el-form-item>

        <el-form-item :label="$t('initUnTradeRecordPage.businessOrderno')" >
          <el-input v-model="formData.untr.utrMerOrderno" :disabled="true"/>
        </el-form-item>


        <el-form-item :label="$t('initUnTradeRecordPage.tradeMoney')" >
          <el-input v-model="formData.untr.utrCurrency" :disabled="true"/>
        </el-form-item>
        <el-form-item :label="$t('initUnTradeRecordPage.returnurl')"  >
          <el-input v-model="formData.untr.utrReturnurl" :disabled="true"/>
        </el-form-item>
        <el-form-item :label="$t('initUnTradeRecordPage.tradingURL')"  >
          <el-input v-model="formData.untr.utrWebsite" :disabled="true"/>
        </el-form-item>
        <el-form-item :label="$t('initUnTradeRecordPage.submiturl')"  >
          <el-input v-model="formData.untr.utrSubmiturl" :disabled="true"/>
        </el-form-item>
        <el-form-item :label="$t('initUnTradeRecordPage.tradeTime')" >
          <el-input v-model="formData.untr.utrPaystarttime" :disabled="true"/>
        </el-form-item>
        <el-form-item :label="$t('initUnTradeRecordPage.wrongcode')"  >
          <el-input v-model="formData.untr.utrErrorcode" :disabled="true"/>
        </el-form-item>
        <el-form-item :label="$t('initUnTradeRecordPage.wronginfo')"  >
          <el-input v-model="formData.untr.utrErrorreasonOut" :disabled="true"/>
        </el-form-item>
        <el-form-item :label="$t('initUnTradeRecordPage.cardCountry')" >
          <el-input v-model="formData.binCountry" :disabled="true"/>
        </el-form-item>
        <el-form-item :label="$t('initUnTradeRecordPage.ipCountry')"  >
          <el-input v-model="formData.ipCountry" :disabled="true" class="heavy-disabled"/>
        </el-form-item>


      </el-form>



    </el-drawer>

  </div>




</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {
      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.UnnormalTraderRecordReqVo.startDate) {
            return false;
          }

          return (
              time.getTime() <
              new Date(this.UnnormalTraderRecordReqVo.startDate).getTime()
          );
        }
      },
      loading: false,
      UnnormalTraderRecordReqVo: {
        startDate: "",
        endDate: "",
        businessmanNo:"",
        gatewayNo:"",
        randomOrderno:"",
        businessOrderno:"",
        expReason:"",
        tradingURL:"",
        remark:"",

        time: 'GMT+08:00',
        maMerLgginAccount: "",

        sortField: undefined,
        sortOrder: undefined
      },

      gatewayList: [],
      timeList: [],
      moreDialogVisible: false,

      currentField: null,     // 当前正在编辑的字段名，如 'orderNo'
      hasSearched: false,   //  是否有进行查询
      downloadLoading: false,

      selectedRowId:"",
      selectedRowData: "",

      checkAllCurrency: false,
      dialogVisible:false,

      updateLoading: false,
      tableData: [],

      columnWidths:{},

      formData: {
        untr:[],
        binCountry:"",
        cardCountry:"",
        ipCountry:"",

      },
      handleDrawerClose(done) {
        this.formData = {
          untr: {
            utrNo: '',
            utrMerNo: '',
            gwNoName: '',
            utrMerOrderno: '',
            utrCurrency: '',
            utrReturnurl: '',
            utrWebsite: '',
            utrSubmiturl: '',
            utrPaystarttime: '',
            utrErrorcode: '',
            utrErrorreasonOut: ''
          },
          binCountry: '',
          ipCountry: ''
        };

        this.checkAllCurrency = false;
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
        });

        done();
      },
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",


    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    this.setDefaultTime(); //时间设置
    // 网关号
    this.getGatewayOptions();
    this.getTimeOptions();
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  watch:{
    '$i18n.locale'(newVal, oldVal) {
      this.getTimeOptions();
    }
  },
  methods: {
    setDefaultTime() {
      const now = new Date();

      // 当天开始时间
      const start = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          0,
          0,
          0
      );

      // 当天结束时间
      const end = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          23,
          59,
          59
      );

      this.UnnormalTraderRecordReqVo.startDate = this.formatDateTime(start);
      this.UnnormalTraderRecordReqVo.endDate = this.formatDateTime(end);
    },
    formatDateTime(date) {
      const pad = (n) => String(n).padStart(2, '0');

      return (
          date.getFullYear() +
          '-' +
          pad(date.getMonth() + 1) +
          '-' +
          pad(date.getDate()) +
          ' ' +
          pad(date.getHours()) +
          ':' +
          pad(date.getMinutes()) +
          ':' +
          pad(date.getSeconds())
      );
    },
    // 网关号
    async getGatewayOptions() {
      try {

        const res = await this.$axios.get('/api/gateway/getlist');
        if (res.data.code === 0) {

          this.gatewayList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
          this.gatewayList = [];
        }



      } catch (error) {
        console.error('获取网关下拉列表失败:', error);
      }
    },
    // 时区
    async getTimeOptions() {
      try {
        this.timeList=[]
        const res = await this.$axios.get('/api/unnormal/traderecord/getTime');
        if (res.data.code === 0) {

          this.timeList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
          this.timeList = [];
        }

      } catch (error) {
        console.error('获取网关下拉列表失败:', error);
      }
    },
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.UnnormalTraderRecordReqVo.sortField = undefined;
        this.UnnormalTraderRecordReqVo.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.UnnormalTraderRecordReqVo.sortField = prop;
        this.UnnormalTraderRecordReqVo.sortOrder = order;
      }

      // 重新调用获取列表的接口
      this.fetchOrderList();
    },



    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          startDate : this.UnnormalTraderRecordReqVo.startDate || undefined,
          endDate : this.UnnormalTraderRecordReqVo.endDate || undefined,
          businessmanNo : this.UnnormalTraderRecordReqVo.businessmanNo || undefined,
          gatewayNo : this.UnnormalTraderRecordReqVo.gatewayNo || undefined,
          randomOrderno : this.UnnormalTraderRecordReqVo.randomOrderno || undefined,
          businessOrderno : this.UnnormalTraderRecordReqVo.businessOrderno || undefined,
          expReason : this.UnnormalTraderRecordReqVo.expReason || undefined,
          tradingURL : this.UnnormalTraderRecordReqVo.tradingURL || undefined,
          remark : this.UnnormalTraderRecordReqVo.remark || undefined,
          time : this.UnnormalTraderRecordReqVo.time || undefined,


          cancelTyep:"0",

          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/unnormal/traderecord/list',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 订单详细信息
    async handleDetail(){
      if(!this.selectedRowId){
        this.$message.warning(this.$t('alert_select'));
        return;
      }

      const params = {
        id : this.selectedRowId,
      };
      const res = await this.$axios.post('/api/unnormal/traderecord/openundetail',  params );
      if (res.data.code === 0){
        const responseData = res.data.data;

        this.formData.untr = responseData.untr;
        this.formData.binCountry = responseData.binCountry;
        this.formData.cardCountry = responseData.cardCountry;
        this.formData.ipCountry = responseData.ipCountry;


      }
      this.dialogVisible = true;
    },
    // 下载
    async handledownload() {
      this.downloadLoading = true;
      this.$message.info(this.$t('DownloadInfo'));
      try {

        const params = {
          startDate : this.UnnormalTraderRecordReqVo.startDate || undefined,
          endDate : this.UnnormalTraderRecordReqVo.endDate || undefined,
          businessmanNo : this.UnnormalTraderRecordReqVo.businessmanNo || undefined,
          gatewayNo : this.UnnormalTraderRecordReqVo.gatewayNo || undefined,
          randomOrderno : this.UnnormalTraderRecordReqVo.randomOrderno || undefined,
          businessOrderno : this.UnnormalTraderRecordReqVo.businessOrderno || undefined,
          expReason : this.UnnormalTraderRecordReqVo.expReason || undefined,
          tradingURL : this.UnnormalTraderRecordReqVo.tradingURL || undefined,
          remark : this.UnnormalTraderRecordReqVo.remark || undefined,
          time : this.UnnormalTraderRecordReqVo.time || undefined,


          cancelTyep:"0",
        };


        const res = await this.$axios.post('/api/unnormal/traderecord/export', params, {
          responseType: 'blob'
        });

        //
        if (res.data.type === 'application/json' || (res.headers['content-type'] && res.headers['content-type'].includes('application/json'))) {
          const reader = new FileReader();
          reader.onload = () => {
            const errorData = JSON.parse(reader.result);
            this.$message.error(errorData.msg || '导出失败');
          };
          reader.readAsText(res.data);
          return;
        }

        // 构造 Blob 对象
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });

        if (res.headers['x-export-truncated'] === 'true') {
          const original = res.headers['x-export-original-size'];
          const exported = res.headers['x-exported-size'];
          const warningText = this.$t('export_truncated_warning').replace('{exported}', exported).replace('{original}', original);
          this.$message.warning(warningText);
        }

        //从请求头 Content-Disposition 中获取文件名 (需要后端配合暴露该 Header，否则使用默认值)
        let fileName = `风险挡掉交易_${new Date().getTime()}.xlsx`;
        const disposition = res.headers['content-disposition'];
        if (disposition && disposition.includes('attachment')) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            // 解决中文乱码问题
            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
          }
        }

        // 创建隐藏的 <a> 标签实现下载
        const downloadElement = document.createElement('a');
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载

        // 清理资源
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href); // 释放掉blob对象

        this.$message.success(this.$t('export_success'));
      } catch (err) {
        console.error('导出Excel失败:', err);
        this.$message.error(this.$t('export_fail'));
      } finally {
        this.downloadLoading = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 处理选择id
    handleRadioChange(row) {
      this.selectedRowData = row;

    },



    // 表头宽度
    initColumnWidths() {
      const cols = [
        "gatewayNo",
        "randomOrderno",
        "businessOrderno",
        "tradeMoney",
        "tradeTime",
        "wrongcode",
        "wronginfo",
        "remark",

      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
            `initUnTradeRecordPage.${key}`
        );

        this.$set(
            this.columnWidths,
            key,
            Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}
/* 按钮独占一行 */
.btn-row {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-row .el-button + .el-button {
  margin-left: 10px;
}

/* 按钮 */
.btn-row .el-button {
  font-weight: 700;
  font-size: 14px;
  padding: 10px 24px;
  border-radius: 6px;
  min-width: 80px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 140px;
  text-align: right;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}


/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

/*.drawer-form {

}*/


.heavy-disabled /deep/ .el-input__inner {
  padding-right: 20px;
  color: #333333 !important;
  font-weight: bold !important;
  -webkit-text-fill-color: #333333 !important;
}
.query-card ::v-deep .el-form-item.btn-row {
  display: flex !important;
  justify-content: center !important;
  margin-right: 0 !important; /* 抵消 inline 表单的右边距 */
}

/* 让 grid 子项独占一整行 */
.query-grid > .full-row {
  grid-column: 1 / -1; /* 从第1列到最后一列 */
}

/* 三列铺满整个卡片 */
.query-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  /*column-gap: 80px;*/
  column-gap: clamp(24px, 5vw, 80px);
  row-gap: 0;
  width: 100%;
}
/* 响应式 */
@media (max-width: 1200px) {
  .query-grid {
    column-gap: 30px;
  }
}

@media (max-width: 992px) {
  .query-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .query-grid {
    grid-template-columns: 1fr;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/merTradeMgr/initUnTradeRecordPage.vue